
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function openMenu() {
  var a = $('header'),
    b = $('body'),
    c = $('#mobMenu'),
    d = $('.mobile-menu-icon'),
    e = $('.mobFix'),
    mobMenuText = $('.mobile-menu-text')
  if (d.hasClass('ON')) 
  {
    c.removeClass('ON');
    setTimeout(function() {
      a.removeClass('ON');
      b.css('overflow', 'auto');
      b.removeClass('drawer-open');
      c.slideUp(300);
      d.removeClass('ON');
      e.removeClass('ON');
      mobMenuText.text('Menu');
    }, 300);
  } else 
  {
    a.addClass('ON');
    b.css('overflow', 'hidden');
    b.addClass('drawer-open');
    c.slideDown(300);
    d.addClass('ON');
    mobMenuText.text('Close');
    setTimeout(function() {
      c.addClass('ON');
      e.addClass('ON')
    }, 300);
  }
}

function setpopmargins() {
  $('.popOuts .inner.ON').css('margin-top', -($('.popOuts .inner.ON').outerHeight() / 2))
  $('.popOuts .inner.ON').css('margin-left', -($('.popOuts .inner.ON').outerWidth() / 2))
}
//BS
function BS() {
  $('.bs').each(function() {
    var t = $(this)
    var d = t.attr('data-img')
    if (t.hasClass('ni')) {
      var a = t.width() / t.attr('data-aspect')
      t.height(a)
    } else {
      if (t.hasClass('sw')) {
        var a = t.width() / t.attr('data-aspect')
        if (t.hasClass('trim')) {
          a = (t.width() / t.attr('data-aspect')) - t.attr('data-trim')
        }
        t.height(a)
        t.backstretch(d)
      }
      if (t.hasClass('lh')) {
        var x = t.attr('data-getSize'),
          x = $('.' + x).outerHeight()
        t.height(x)
        t.backstretch(d)
      }
      if (!t.hasClass('sw') && !t.hasClass('lh')) {
        t.backstretch(d)
      } 
    }
  });
}

function mixitFilter() {
  var b = $('a.filter.ON')
  if (b.length > 0) {
    var a = b.map(function() {
      return $(this).attr('href')
    }).get().join(",").replace(/,/g, "");
    console.log(a)
    $('#mixit').mixItUp('filter', a)
  } else {
    $('#mixit').mixItUp('filter', 'all');
  }
}
//mixitup
function mixit() {
  var $mixcontainer = $('#mixit')
  if ($mixcontainer) {
    $mixcontainer.imagesLoaded(function() {
      $mixcontainer.mixItUp({
        load: {
          filter: 'all',
          sort: 'bydate:asc'
        },
        controls: {
          enable: false
        },
        animation: {
          duration: 210,
          effects: 'fade',
          easing: 'ease'
        },
        callbacks: {
          onMixLoad: function(state) {
            $('#mixit').animate({
              'opacity': 1
            }, 200);
            BS();
          }
        }
      });
    });
  } 
}
//PAGINATE///
function paginateCollection() {
  var wnd = $(window).width()
  if ( $('.pagniate').length > 0 ) {
    if (wnd > 980 && $('.pagniate.ON').length < 1) {
      
      var pages_count = $('.pagniate').attr('data-collection-count')
      pages_count = pages_count / 48
      pages_count = Math.ceil(pages_count)
      if (pages_count > 1) {
        var base_url = location.pathname + "?page=",
          i = 2,
          collection = $('.collectionListing');
        var ajaxCalls = pages_count - 1;
        var counter = 0;
        var ajaxCallComplete = function() {
          counter++;
          if (counter === ajaxCalls) {
            mixit();
            $('.pagniate').addClass('ON')
          }
        }
        for (i = 2; i <= pages_count; i++) {
          var getme = base_url + i
          $.get(getme, function(data) {
            var items = $(data).find('.collectionItem');
            collection.append(items);
          }).complete(function() {
            ajaxCallComplete()
          });
        }
      } else {
        mixit();
      }
    } else {
      if ($('.pagniate.ON').length < 1) {
        $('.paginationWrap').show();
        mixit();

      } else {
        $('.paginationWrap').hide();
        mixit();
      }
    }
  }
} //END PAGINATE//
function createVid() {
  $('.vidWrapper').each(function(i) {
    var getVidID = $(this).attr('data-vid');
    var vidVars = function() {
      var playerT = "player" + (i)
      var players = new YT.Player(playerT, {
        height: '720',
        width: '1280',
        playerVars: {
          'PlaybackQuality': 'large',
          'rel': 0,
          'loop': 0,
          'controls': 1,
          'showinfo': 1,
          'enablejsapi ': 1,
          'wmode': 'opaque',
          'playlist': getVidID
        },
        videoId: getVidID,
        events: {
          'onReady': function() {
            players.mute();
          },
        }
      });
    }
    vidVars()
  }).promise().done(function() {});
}
//SET HEIGHTS
function setHeights() {
  $('.thumb .imageWrap img').css('max-width', $('.thumb .imageWrap').width() - 40)
}

$(document).ready(function() {
  var wndwth = $(window).width()
  BS()
  paginateCollection()
    //header + mob menu
    //mobmenu
  $('.mobile-menu-icon').click(function(e) {
    e.preventDefault();
    openMenu();
  });
  $('.hasmobChild').click(function(e) {
    e.preventDefault();
    var t = $(this),
      a = t.attr('data-getmobdropdown'),
      a = $('#' + a),
      b = $('.hasmobChild'),
      c = $('.mobdropMenu')
    if (!t.hasClass('ON')) {
      c.slideUp(200);
      b.removeClass('ON');
      a.slideDown(200);
      t.addClass('ON')
    } else {
      c.slideUp(200);
      b.removeClass('ON');
    }
  });
  
  if ( $('.collDesc').length > 0 ) {
  	$('.collDesc').readmore({
  		speed: 200,
      	collapsedHeight: 500,
		blockCSS: '',
  		lessLink: '<a href="#">Read less</a>'
	});
  }

  //INDEX
  jQuery(document).ready(function ($) {
    if ($("#homeHero").length > 0 ) {
      $("#homeHero").cycle({
        fx: "scrollHorz",
        prev: ".homeHeroControl.prev",
        next: ".homeHeroControl.next",
        timeout: 5000,
        slides: "li"
      });
    }
  });
  
  //PRODUCT
    //product Tabs
  $('.tabWrap li').click(function() {
    var t = $(this),
      a = t.attr('data-id'),
      b = $('.' + a)
    if (t.hasClass('ON')) {} else {
      t.closest('.tabWrap').find('li').removeClass('ON');
      t.addClass('ON')
      t.closest('.productFiler').find('.inner').hide();
      setTimeout(function() {
        b.show()
      }, 0)
    }
  }); //product Tabs
  //showreviews
  $(document).on('click', '.yotpoWrap .star-clickable a', function(event) {
    event.preventDefault()
    $('.tabWrap li').removeClass('ON');
    $('.reviewsTab').addClass('ON')
    $('.productFiler .inner').fadeOut(400);
    setTimeout(function() {
      $('.reviews').fadeIn(200)
    }, 400)
  });
  //qty
  $('.quantInput span').click(function() {
    var t = $(this),
      a = t.parent().find('input'),
      b = a.val(),
      c = a.attr('min'),
      x = +b + 1,
      y = +b - 1
    if (t.hasClass('plus')) {
      a.val(x);
    } else {
      if (b > 0 && y > c) {
        a.val(y);
      }
    }
  });
  //thumbimage  
  // $('.imageGallery .thumbs a').click(function(event) {
  //   event.preventDefault()
  //   var t = $(this),
  //     b = t.attr('data-imgref'),
  //     c = $('.featImg'),
  //     d = t.attr('data-zoomimgref')
  //   c.attr('src', b)
  //   $('.zoomWindowContainer div').stop().css("background-image", "url(" + d + ")");
  // });

// Zoom code removed from here, see older versions of the theme if it needs to be put back
  
  //logins
  $('.forgotP').click(function(event) {
    event.preventDefault()
    $('#regLog').hide();
    $('#forgotPass').show()
  });
  $('.forgotPCancel').click(function(event) {
    event.preventDefault()
    $('#forgotPass').hide();
    $('#regLog').show()
  });
  //filters
  $('.showFilter').click(function(event) {
    event.preventDefault()
    var t = $(this),
      a = t.attr('href'),
      a = $('.controlsWrap').find(a),
      b = $('.showFilter.ON'),
      c = b.attr('href'),
      c = $('.controlsWrap').find(c),
      d = $('.filterTop')
    if (!t.hasClass('ON')) {
      t.addClass('ON');
      b.removeClass('ON');
      d.addClass('ON')
      var z = c.find('.ON').length
      if (z > 0) {
        b.addClass('hasactive')
      } else {
        b.removeClass('hasactive')
      }
      c.hide();
      a.show();
    } else {
      var z = a.find('.ON').length
      if (z > 0) {
        t.addClass('hasactive')
      } else {
        t.removeClass('hasactive')
      }
      t.removeClass('ON')
      a.hide()
      d.removeClass('ON')
    }
  });
  $('a.filter:not(.iso)').click(function(event) {
      event.preventDefault()
      var t = $(this)
      if (!t.hasClass('ON')) {
        t.addClass('ON')
      } else {
        t.removeClass('ON')
      }
      array_of_filters = []
      $('a.filter.ON').each(function(){
		array_of_filters.push($(this).attr('href'));
      });
      setCookie('array_of_filters', JSON.stringify(array_of_filters), 30)
      mixitFilter()
    }) //filters a
  $('a.sort:not(.iso)').click(function(event) {
      event.preventDefault()
      var t = $(this),
        a = t.attr('data-sort'),
        b = $('a.sort')
      if (!t.hasClass('ON')) {
        b.removeClass('ON')
        t.addClass('ON')
        $('#mixit').mixItUp('sort', a);
      } else {
        t.removeClass('ON')
        $('#mixit').mixItUp('sort', 'default');
      }
    }) //sort a
  if ($(window).width() > 980) {
    //par scroll
    var boxes = $('[data-scroll-speed]'),
      $window = $(window);
    $window.on('scroll', function() {
      var scrollTop = $window.scrollTop();
      boxes.each(function() {
        var $this = $(this),
          scrollspeed = parseInt($this.data('scroll-speed')),
          val = -scrollTop / scrollspeed;
        $this.css('transform', 'translateY(' + val + 'px)');
      });
    }); //par scroll
  } 
  $('.filterTitle').on('click', function(){
    $(this).toggleClass('filter-opened');
    $(this).next('.filters').fadeToggle();
  });
  if($('#filterTags').length){
    setTimeout(function(){
      if (getCookie('array_of_filters') != ''){
        array_of_filters = JSON.parse(getCookie('array_of_filters'))
        $('a.filter:not(.iso)').each(function(){
          elem = $(this)
          elem_href = $(this).attr('href')
          $.each(array_of_filters, function( index, value ) {
            if(elem_href == value){
              elem.addClass('ON')
            }
          });
        });
        mixitFilter();
      }
    }, 2000);
  }

  //PopOuts open
  $(document).on("click", ".hasPop", function(event) {
    event.preventDefault()
    var t = $(this),
      a = t.attr('data-getPop'),
      a = $('#' + a),
      b = $('.popOuts'),
      c = $('body')
    c.css('overflow-y', 'hidden');
    b.fadeIn(400);
    a.show();
    $('.popOuts .innerWrap').show();
    a.addClass('ON')
    setpopmargins()
    setTimeout(function() {
      $('.popOuts .innerWrap').addClass('ON')
    }, 600)
    setTimeout(function() {
        $('.popOuts .overFlowFix').css('overflow-y', 'auto')
      }, 1200)
      //popouts Close 
    $('.popOuts .closePop').click(function(event) {
      event.preventDefault()
      $('.popOuts .inner.ON').removeClass('ON')
      $('.popOuts .innerWrap.ON').removeClass('ON')
      setTimeout(function() {
        $('.popOuts .inner').hide();
        $('.popOuts').fadeOut(400);
        BS()
      }, 400)
      setTimeout(function() {
        $('.popOuts .overFlowFix').css('overflow-y', 'hidden')
        c.css('overflow-y', 'auto')
      }, 800)
    }); //close
  }); //popOuts
  
  // custom length pop up
  $('.add-to-cart.button').click(function() {
  	var value = $('select#select_size option:selected').attr('data-hascustom');
    for(var i=1; i < $('.quantInput input[name=quantity_for_custom_size]').val(); i++) {
      $('#customInfoID').val(Math.round(Math.random() * (999999999 - 100000000)));
      var formData = new FormData($('form[action="/cart/add"]')[0]);

      jQuery.ajax({
        type: "POST",
        contentType: false, // NEEDED, DON'T OMIT THIS (requires jQuery 1.6+)
        processData: false, // NEEDED, DON'T OMIT TH
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        async: false
      });

      /*jQuery.ajax({
        type: "POST",
        url: '/cart/add.js',
        data: $('form[action="/cart/add"]').serialize(),
        async: false
      });*/
    }

    if( value == 'true' ) {
      //console.log( getCookie( "shown" ) );
//          location.reload();
//       if( getCookie( "shown" ) != 'yes' ){
//        	setCookie( "shown", "yes", 1 );
//         $('.popOuts').show();
//         $('.popOuts .innerWrap').show();
//         $('.popOuts .innerWrap').addClass('ON');
//         $('.popOuts .innerWrap #custom-length').fadeIn(400);
//       }
    }
  });
  $('.customLengthGoBack').click(function(){
  	$('.popOuts').delay(600).hide();
    $('.popOuts .innerWrap').delay(600).hide();
    $('.popOuts .innerWrap').removeClass('ON');
    $('.popOuts .innerWrap #custom-length').fadeOut(400);
  });
  // custom length pop up
  
  // custom size reset //
  	$("select#select_size").change(function(){
  		var value = $("select#select_size option:selected").attr("data-hascustom");
  	
      if( !value ){
        $("input.customLength").val("");
      }
    });
  // custom size reset //
  
  // show custom size text //
  	if( $("select#select_size") ){
      
      var attributes = [];
      
      $("select#select_size > option").each(function(){
        if( typeof $(this).attr("data-hascustom") === "undefined" ){
         	attributes.push( "no" ); 
        }
        else{
          	attributes.push( "yes" ); 
        }
      });
      
      if( $.inArray("yes", attributes) !== -1 ){
        $("label > #custom-size-label").show();
      }
  	}
  // show custom size text //
  
  //main subs
  var mouseout2_triger

  function mousein_triger(event) {
    event.preventDefault()
    var t = $(this),
      a = t.attr('data-getDropdown'),
      a = $('.subMenus #' + a),
      tmout = 0,
      b = $('.tranTopFix')
    if (t.hasClass('hasChild')) {
      if ($('.hasChild.ON').length > 0) {
        if (!t.hasClass('ON')) {
          $('.hasChild').removeClass('ON');
          $('.dropMenu').removeClass('ON')
          t.addClass('ON')
          a.addClass('ON')
        }
      } else {
        if (b.length > 0) {
          $('.proxyHeader').addClass('ON');
          tmout = 0
        }
        t.addClass('ON')
        a.addClass('ON')
        $('.subMenus').show()
      }
    } else {
      mouseout2_triger()
    }
  } //mousein_triger
  mouseout2_triger = function() {
    $('.subMenus').hide()
    $('.hasChild').removeClass('ON');
    $('.dropMenu').removeClass('ON')
    $('.proxyHeader').removeClass('ON')
  }

  function mouseout_triger() {}

  function mousein2_triger() {}
  $(".header nav a").hoverIntent(mousein_triger, mouseout_triger);
  $(".dropProxy").hoverIntent(mousein2_triger, mouseout2_triger);
  var customSize = $('.customSize')
  var customLength = $('.customLength')
  var customWidth = $('.customWidth')
  var customWidth
  var customPrice = $('.customPrice')
  var unitPrice = customSize.attr('data-unitPrice')
  var customVar
  var mm2
  var qtyWrap = $('.qtyWrap')
  var customInfoLength = $('#customInfoLength')
  var customInfoWidth = $('#customInfoWidth')
  var select_color = $('#select_colour')
  var customInfoColor = $('#customInfoColor')
  var prodString = ""
  var hiddenVariants
  var addtocart = $('#add-to-cart')
  var itemStock
  var inputUpdate = $('.prodID')
  var quantUpdate = $('.quantInput input[name=quantity]')

  function updateCustomSizes() {
    if(customLength.val() >= 50) {
      $('.add-to-cart').removeClass('disable-click');
    } else {
      $('.add-to-cart').addClass('disable-click');
    }

    var productString = $('form.multioptions select.productSelect option[data-hasCustom="true"]:selected').val(),
    prodString = 'customlength' + productString.match(/\d+cm/) + 'widepercm'
    if (productString.match(/\d+mmheight/)) {
      prodString += productString.match(/\d+mmheight/)
    }

    prodString = "cuttofit" + prodString;
    unitPrice = $('form.multioptions select.productSelect option[data-hasCustom="true"]:selected').attr('data-customUnitPrice');
    unitPrice = parseFloat(unitPrice);
    unitPrice = unitPrice.toFixed(2);
    hiddenVariants = $('.hiddenVariants');
    hiddenVariants = hiddenVariants.find('span').filter('[data-title="' + prodString + '"]');
    if (hiddenVariants.length > 0) {
      itemStock = hiddenVariants.attr('data-stock');
      addtocart.val('add to cart').removeClass('dis').prop("disabled", false);
      inputUpdate.val(hiddenVariants.attr('data-var'));
      /* if(itemStock < 1){
         addtocart.val('Out Of Stock').addClass('dis').prop("disabled", true);  
      } */
    } else {
      addtocart.val('Out Of Stock').addClass('dis').prop("disabled", true);
    }

    console.log(customLength.val());
    console.log(unitPrice);
    customPrice.find('.with-out-vat').text(parseFloat(customLength.val() * unitPrice).toFixed(2));
    customPrice.find('.with-vat').text(parseFloat(customLength.val() * unitPrice * 1.20).toFixed(2));
    quantUpdate.val(customLength.val());
    customInfoLength.val(customLength.val());
    customInfoWidth.val(customWidth.val());
    customInfoColor.val(select_color.val());
  }

  customSize.find('input').change(function() {
    updateCustomSizes();
  }).keyup(function() {
    updateCustomSizes();
  });

  function showCustomSizes() {
    if (customSize.is(':hidden')) {
      qtyWrap.addClass('hide');
      customSize.slideDown();
      addtocart.val('add to cart').removeClass('dis').prop("disabled", false);
      updateCustomSizes()
    }
  }
  //product form
  
  function getpage(){
    setTimeout(function(){
        var root = window.location.href;       
        $.ajax({
          type:"GET",
          url:root,
          dataType:'HTML',
          success:function(result) {
            $('#vat-price-wrapper .compare-price s').html($(result).find('#vat-price-wrapper .compare-price s').html());
          }
        });
      }, 500);
  }
  function updateProduct() {
    
    $('form.multioptions').each(function() {
      hiddenVariants = $(this).find('.hiddenVariants');
      prodString = "";
      $(this).find('select.productSelect option:selected').each(function() {
        var t = '';
        var dataValue = $(this).data('value');
        if ($(this).attr('data-hasCustom') == 'true') {
          if(typeof dataValue != 'undefined') {
            t = 'customlength' + $(this).attr('data-value').match(/\d+cm/) + 'widepercm';
            if ($(this).attr('data-value').match(/\d+mmheight/)) {
              t += $(this).attr('data-value').match(/\d+mmheight/);
            }
          } else {
            if($(this).val().match(/\d+cm/) == null) {
              t = $(this).val();
            } else {
              t = 'customlength' + $(this).val().match(/\d+cm/) + 'widepercm';
              if ($(this).val().match(/\d+mmheight/)) {
                t += $(this).val().match(/\d+mmheight/);
              }
            }
          }
        } else {
          if(typeof dataValue != 'undefined') {
            t = $(this).attr('data-value');
          } else {
            t = $(this).val();
          }
        }
        prodString += t;
        console.log(prodString);
      }).promise().done(function() {
        $('.varint-part-numbers').hide();
        $('.part_no_strng').hide();
        $('#part-number').val("");
        $('.line-item-property__field').html("");
        hiddenVariants = hiddenVariants.find('span').filter('[data-title="' + prodString + '"]');
        partNumberValues = hiddenVariants.attr('data-var-partnumber');
        if(partNumberValues != ''){          
          $('.varint-part-numbers').html(partNumberValues).show();
          $('.part_no_strng').show();
          $('#part-number').val(partNumberValues);
          $('.line-item-property__field').html($('#variant_part_number').html());
        }
        var featImg = $('.featImg'),
            large = hiddenVariants.attr('data-varimgLarge');
        $('.zoomWindowContainer div').stop().css("background-image", "url(" + large + ")");
        featImg.attr('src', large);
        if (hiddenVariants.length > 0) {
          itemStock = hiddenVariants.attr('data-stock');
          addtocart.val('add to cart').removeClass('dis').prop("disabled", false);
          inputUpdate.val(hiddenVariants.attr('data-var'));
            /*if(itemStock < 1){
               addtocart.val('Out Of Stock').addClass('dis').prop("disabled", true);  
            }*/
          $('#price-wrapper span.price').text(hiddenVariants.data('var_price'));
          var var_price_unformatted = parseInt(hiddenVariants.data('var_price_unformatted'));
          var total_exclude_compareprice =  hiddenVariants.data('var_comp_price');

          // Bulk Discount table
          if($('.discount-table').length) {
            var variantId = hiddenVariants.attr('data-var');
            $('.discount-table tr').hide();
            $(`.discount-table tr[data-variant="${variantId}"]`).show();
          }
          // End Bulk Discount table

          if(total_exclude_compareprice){
            getpage();
          }
          $('#vat-price-wrapper span.price').text(hiddenVariants.data('var_price'));
          $('#vat-price-wrapper span.priceexcl').text(hiddenVariants.data('var-include-vat'));
          if(var_price_unformatted < 150) {
            $('#price-wrapper span.cm_text').show();
          } else {
            $('#price-wrapper span.cm_text').hide();
          }

          if(typeof hiddenVariants.data('var_price') != 'undefined') {
            $('#price-wrapper span.compare-price s').text(hiddenVariants.data('var_comp_price'));
            $('#price-wrapper span.compare-price').show();
          } else {
            $('#price-wrapper span.compare-price').hide();
          }
        } else {
          addtocart.val('Out Of Stock').addClass('dis').prop("disabled", true);
        }
      });
    })
  }
  $('form.multioptions select').change(function() {
    var flag = (!$('form.multioptions select option[data-hasCustom="true"]').is(':selected'));
    if (flag) {
      customSize.slideUp();
      $('.add-to-cart').removeClass('disable-click');
      updateProduct();
      qtyWrap.removeClass('hide');
      quantUpdate.val(1);
      customInfoLength.val(customLength.val());
      customInfoWidth.val(customWidth.val());
    }  else {
      showCustomSizes();
      updateCustomSizes();
      updateProduct();
    }
  });
  /*
  $('.sumbitProx').click(function(e) {
    e.preventDefault();
    var t = $(this),
      a = t.closest('form')
    a.validate();
    if (a.valid()) {
      t.css({
        'background': 'green'
      }).text("sending")
      setTimeout(function() {
        t.css({
          'background': '#7a88b9'
        }).text("Sent, thanks for your request")
        a.submit()
      }, 2500)
    } else {
      t.css({
        'background': 'red'
      }).text("Please comlplete all fields")
      setTimeout(function() {
        t.css({
          'background': '#7a88b9'
        }).text("submit request")
      }, 2500)
    }
  });
  */
  ///////////////
}); //ready


$(window).on("load",function() {
  //functions
  BS()
  if ($('.vidWrapper').length > 0) {
    createVid();
  }
  $('.mobFix').imagesLoaded(function() {
    $('.mobFix').animate({
      'opacity': 1
    }, 400);
  });
}); //load
$(window).resize(function() {
  //functions
  BS();
  paginateCollection();
}); //resize
$(window).scroll(function() {
  //pop down header
  var hdr = $('.scrollFX'),
    subhdr = $('.tranTopJQ')
  if ($(this).scrollTop() > 200) {
    hdr.addClass('onScroll')
    subhdr.removeClass('tranTopFix')
  } else {
    hdr.removeClass('onScroll')
    subhdr.addClass('tranTopFix')
  }
}); //scroll

$('form .multioptions').submit(function (event) {
  event.preventDefault();
})

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
  	var path = window.location.pathname;
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path="+ path +"";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
$(".allownumericwithdecimal").on("keypress keyup blur",function (event) {
  //this.value = this.value.replace(/[^0-9\.]/g,'');
  $(this).val($(this).val().replace(/[^0-9\.]/g,''));
  if ((event.which != 46 || $(this).val().indexOf('.') != -1) && (event.which < 48 || event.which > 57)) {
    event.preventDefault();
  }
});

$(".allownumericwithoutdecimal").on("keypress keyup blur",function (event) {    
  $(this).val($(this).val().replace(/[^\d].+/, ""));
  if ((event.which < 48 || event.which > 57)) {
    event.preventDefault();
  }
});


if($(".pagination").length) {
  var fniv = $(".pagination .prev").next("span").find("a").attr("href");

  if(fniv.indexOf("?page=1") >= 0) {
    let newval = fniv.replace('?page=1','');
    $(".pagination .prev").next("span").find("a").attr("href", newval);
  }

  if($(".pagination .prev").length){
    if($(".pagination .prev a").attr("href").indexOf("?page=1") >= 0) {
      let newval = fniv.replace('?page=1','');
      $(".pagination .prev a").attr("href", newval);
    }
  }
}

$(document).ready(function() {
  $("#BuyNowBtnClick").click(function(event) {
    event.preventDefault();
    var variant_id = $('input[name="id"].prodID').val();
    var item = {};
    item.id = variant_id;
    item.quantity = 1;
    var data = item;
    $.ajax({
      type: 'post',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
        window.location.href = '/cart';
      }
    });
    return false;
  });
});

$(document).ready(function () { 
  $("#searchTab").click(function () {
    $(".searchBox").toggleClass("showSearch hideSearch");
  });

  $(window).on("resize", function () {
    var headHeight = $('.header').outerHeight();
    var undernavHeight = $('.undernav').height();
    var totalMargin = headHeight + undernavHeight;

    $('.homepage-slider-banner').css('margin-top', `${totalMargin}px`);
  }).resize();
  

  $('#select_thickness, #select_colour, #select_type').change(function() {
    var value = $(this).val();
    var OptionsHTML = '';
    /* $('#select_roll-size option, #select_size option').removeAttr('selected', 'selected').hide();
    $('#select_roll-size option[data-size-thickness="'+value+'"], #select_size option[data-size-thickness="'+value+'"]').show(); */

    $('#select_roll-size option, #select_size option, #select_platform-size option').remove().end();
    $('#size-options-wrapper option[data-size-thickness="'+value+'"]').each(function() {
      OptionsHTML += $(this)[0].outerHTML;
      // Below code was the reason behind the issue.
      // add the current element to the target element
      // $('#select_roll-size, #select_size, #select_platform-size').append($(this));
    });
    $('#select_roll-size, #select_size, #select_platform-size').append(OptionsHTML);
    var sizevalue = $('#select_roll-size option[data-size-thickness="'+value+'"], #select_size option[data-size-thickness="'+value+'"], #select_platform-size option[data-size-thickness="'+value+'"]').eq(0).attr('selected', 'selected').attr('value');
    $('#select_roll-size, #select_size, #select_platform-size').val(sizevalue).trigger('change');
  });

  $('#select_colour').change(function() {
    var ColorValue = $(this).val();
    const imagePosition = DefaultfindImagePosition(ColorValue);
    if (imagePosition !== null) {
    DefaulttriggerClickOnImagePosition(imagePosition);
    }
  });

  if($('.get-quote').length) {
    var customOptionSelected = false;
    $('#select_size').change(function() {
      var value = $(this).val();
      var orientation = $('.orientation_options input[name="orientation"]:checked').attr('value');
      var formLink = `https://firstmats.typeform.com/to/WJ8k9012#source=Google&medium=ORGANIC_SEARCH&campaign=FM-2023-Form&orientation=${orientation}&size=${value}&type=Indoor`;

      if(value.includes('custom')) {
        customOptionSelected = true;
      } else {
        customOptionSelected = false;
      }
      $('#get-quote-button').attr('href', formLink);
    });

    var getQuoteLength = getQuoteWidth = 0;
    $('.get-quote__customsize .customLength, .get-quote__customsize .customWidth').change(function() {
      if($(this).hasClass('customLength')) {
        getQuoteLength = $(this).val();
      }
      if($(this).hasClass('customWidth')) {
        getQuoteWidth = $(this).val();
      }
      var value = `${getQuoteWidth}cmx${getQuoteLength}cm`;
      var orientation = $('.orientation_options input[name="orientation"]:checked').attr('value');
      var formLink = `https://firstmats.typeform.com/to/WJ8k9012#source=Google&medium=ORGANIC_SEARCH&campaign=FM-2023-Form&orientation=${orientation}&size=${value}&type=Indoor`;

      $('#get-quote-button').attr('href', formLink);
    });

    $('.orientation_options input[name="orientation"]').change(function() {
      var orientation = $(this).val();

      if(customOptionSelected) {
        var value = `${getQuoteWidth}cmx${getQuoteLength}cm`;
      } else {
        var value = $('#select_size').val();
      }

      var formLink = `https://firstmats.typeform.com/to/WJ8k9012#source=Google&medium=ORGANIC_SEARCH&campaign=FM-2023-Form&orientation=${orientation}&size=${value}&type=Indoor`;
      $('#get-quote-button').attr('href', formLink);
    });
  }

  $('#fileInput').on('change', function() {
    var selectedFile = this.files[0];
    
    if (selectedFile) {
      var allowedFormats = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'];
      var maxSize = 20 * 1024 * 1024; // 20MB in bytes
      
      if (allowedFormats.includes(selectedFile.type) && selectedFile.size <= maxSize) {
        console.log("File is valid.");
      } else {
        $('#fileInput').val('');
        alert("Invalid file. Please select a valid file format (JPG, PNG, GIF, PDF) and ensure the file size is under 20MB.");
      }
    }
  });
});
$(document).ready(function() {
  $("#BuyNowBtnClick").click(function(event) {
    event.preventDefault();
    var variant_id = $('input[name="id"].prodID').val();
    var item = {};
    item.id = variant_id;
    item.quantity =1;
    var data = item;
    $.ajax({
      type: 'post',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
        window.location.href = '/cart';
      }
    });
    return false;
  });
});

jQuery(document).ready(function () {
  var a = jQuery;
  a(".add-to-cart:not(.groupAdd)").click(function (b) {
    b.preventDefault();
    if($(this).hasClass('disable-click')) {
      alert('Minimum Length Should be 50cm');
      return;
    }

    $("#customInfoID").val(Math.floor(999999999 * Math.random()));
    if (!$(this).hasClass("dis")) {
      b = $(this).parents("form");
      var a = $(this);
      var formData = new FormData($(this).parents("form")[0]);
      b = {
        type: "POST",
        contentType: false,
        processData: false,
        url: "/cart/add.js",
        // data: jQuery(b).serialize(),
        data: formData,
        dataType: "json",
        success: function (b) {
          window.location.href = "/cart";
          a.addClass("ON");
          setTimeout(function () {
            a.removeClass("ON")
          }, 2E3);
          b = parseInt($("#cart-count").html()) + 1;
          $("#cart-count").html(b)
        },
        error: function (b, a) {
          console.log(b, a)
        }
      };
      jQuery.ajax(b)
    }
  });
  a(".add-to-cart.groupAdd").click(function (b) {
    b.preventDefault();
    $("#customInfoID").val(Math.floor(999999999 * Math.random()));
    var a = $(this);
    if (!$(this).hasClass("dis")) {
      var e, c = [];
      $(".varHolder").each(function () {
        var b = $(this).find("a").attr("data-vardID"),
          a = $(this).find(".quant").val();
        0 != a && (e = "quantity=" + a + "&id=" + b, c.push(e))
      });
      var f = function () {
        if (c.length) {
          var b = c.shift(),
            d = c.length;
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: b,
            dataType: "json",
            success: function (b) {
              if (0 === d) {
                if (a.addClass("ON"), setTimeout(function () {
                    a.removeClass("ON")
                  }, 2E3), "function" !== typeof callback) Shopify.onItemAdded(b)
              } else f()
            }
          })
        }
      };
      c.length && f()
    }
  });
  a("form[name=cartform] input[name=update]").click(function (b) {
    b.preventDefault();
    a(b.target.form).find("input[type=image], input.button-update-cart").attr("disabled", !0).addClass("disabled");
    Shopify.updateCartFromForm(b.target.form)
  });
  a("form[name=cartform]").delegate(".remove", "click", function (b) {});
  Shopify.onItemAdded =
    function (b, a) {
      Shopify.getCart()
    };
  Shopify.onCartUpdate = function (b, d) {
    0 == b.item_count ? $(".menuPopouts .inner#cart").html('<p class="emptyCart">Your cart is empty <a class="emptyCartLink" href="/collections/all">Shop Now</a></p>') : $(".emptyCart").remove();
    var e = Shopify.formatMoney(b.total_price, "$");
    a(".cart-total-price").html(e);
    a("#cart-total").html(Shopify.formatMoney(b.total_price, this.money_format));
    var c = "";
    a.each(b.items, function (b, a) {
      a.title.split("-");
      c += '<a href="' + a.url + '" class="trn2 cart-line-item">    <div class="mc-image">    <img  src="' +
        a.image + '" alt="' + a.title + '"/>    </div>    <div class="mc-title">    <p>' + a.title + '</p>    <section class="mc-price">    <p>' + a.quantity + " x</p>    <p>" + Shopify.formatMoney(a.price, this.money_format) + '</p>    </section>    </div>    <div data-href="' + a.id + '"  class="mc-remove remove">    <p class="table trn2"><span class="cell">remove</span></p>    </div>    </a>'
    });
    a("#sidebar-cart-update").html(c);
    0 < a("#empty").length && 0 == b.item_count && (a("form[name=cartform]").hide(), a("#empty").show());
    (d = d ||
      !1) && 0 < b.item_count && (a.each(b.items, function (b, c) {
      a(".cart-line-item-price-" + c.id).html(Shopify.formatMoney(c.line_price, "$"));
      a("input#updates_" + c.id).val(c.quantity)
    }), a(d).find("input[value=0]").parents(".cart-line-item").remove(), a(d).find("input[type=image], input.button-update-cart").attr("disabled", !1).removeClass("disabled"))
  };
  Shopify.onError = function (a, d) {}
});

"undefined"===typeof Shopify&&(Shopify={});Shopify.money_format="";Shopify.onError=function(a,b){var c=eval("("+a.responseText+")");c.message?alert(c.message+"("+c.status+"): "+c.description):alert("Error : "+Shopify.fullMessagesFromErrors(c).join("; ")+".")};Shopify.fullMessagesFromErrors=function(a){var b=[];jQuery.each(a,function(a,d){jQuery.each(d,function(c,d){b.push(a+" "+d)})});return b};Shopify.onCartUpdate=function(a){alert("There are now "+a.item_count+" items in the cart.")};
Shopify.onCartShippingRatesUpdate=function(a,b){var c="";b.zip&&(c+=b.zip+", ");b.province&&(c+=b.province+", ");c+=b.country;alert("There are "+a.length+" shipping rates available for "+c+", starting at "+Shopify.formatMoney(a[0].price)+".")};Shopify.onItemAdded=function(a){alert(a.title+" was added to your shopping cart.")};Shopify.onProduct=function(a){alert("Received everything we ever wanted to know about "+a.title)};
Shopify.formatMoney=function(a,b){function c(a){return a.replace(/(\d+)(\d{3}[\.,]?)/,"$1,$2")}"string"==typeof a&&(a=a.replace(".",""));var d="",e=/\{\{\s*(\w+)\s*\}\}/,f=b||this.money_format;switch(f.match(e)[1]){case "amount":d=c(floatToString(a/100,2));break;case "amount_no_decimals":d=c(floatToString(a/100,0));break;case "amount_with_comma_separator":d=floatToString(a/100,2).replace(/\./,",");break;case "amount_no_decimals_with_comma_separator":d=c(floatToString(a/100,0)).replace(/\./,",")}return f.replace(e,
d)};Shopify.resizeImage=function(a,b){try{if("original"==b)return a;var c=a.match(/(.*\/[\w\-_\.]+)\.(\w{2,4})/);return c[1]+"_"+b+"."+c[2]}catch(d){return a}};Shopify.addItem=function(a,b,c){jQuery.ajax({type:"POST",url:"/cart/add.js",data:"quantity="+(b||1)+"&id="+a,dataType:"json",success:function(a){if("function"===typeof c)c(a);else Shopify.onItemAdded(a)},error:function(a,b){Shopify.onError(a,b)}})};
Shopify.addItemFromForm=function(a,b){var c={type:"POST",url:"/cart/add.js",data:jQuery(a).serialize(),dataType:"json",success:function(c){if("function"===typeof b)b(c,a);else{var d=$("#add-to-cart");console.log(a);d.val("ITEM ADDED !");setTimeout(function(){d.val("ADD TO CART")},2E3)}},error:function(a,b){Shopify.onError(a,b)}};jQuery.ajax(c)};Shopify.getCart=function(a){jQuery.getJSON("/cart.js",function(b,c){if("function"===typeof a)a(b);else Shopify.onCartUpdate(b)})};
Shopify.getCartShippingRatesForDestination=function(a,b){var c={type:"GET",url:"/cart/shipping_rates.json",data:Shopify.param({shipping_address:a}),dataType:"json",success:function(c){rates=c.shipping_rates;if("function"===typeof b)b(rates,a);else Shopify.onCartShippingRatesUpdate(rates,a)},error:function(a,b){Shopify.onError(a,b)}};jQuery.ajax(c)};Shopify.getProduct=function(a,b){jQuery.getJSON("/products/"+a+".js",function(a,d){if("function"===typeof b)b(a);else Shopify.onProduct(a)})};
Shopify.changeItem=function(a,b,c){jQuery.ajax({type:"POST",url:"/cart/change.js",data:"quantity="+b+"&id="+a,dataType:"json",success:function(a){if("function"===typeof c)c(a);else Shopify.onCartUpdate(a)},error:function(a,b){Shopify.onError(a,b)}})};Shopify.removeItem=function(a,b){jQuery.ajax({type:"POST",url:"/cart/change.js",data:"quantity=0&id="+a,dataType:"json",success:function(a){if("function"===typeof b)b(a);else Shopify.onCartUpdate(a)},error:function(a,b){Shopify.onError(a,b)}})};
Shopify.clear=function(a){jQuery.ajax({type:"POST",url:"/cart/clear.js",data:"",dataType:"json",success:function(b){if("function"===typeof a)a(b);else Shopify.onCartUpdate(b)},error:function(a,c){Shopify.onError(a,c)}})};Shopify.updateCartFromForm=function(a,b){var c={type:"POST",url:"/cart/update.js",data:jQuery(a).serialize(),dataType:"json",success:function(c){if("function"===typeof b)b(c,a);else Shopify.onCartUpdate(c,a)},error:function(a,b){Shopify.onError(a,b)}};jQuery.ajax(c)};
Shopify.updateCartAttributes=function(a,b){var c="";jQuery.isArray(a)?jQuery.each(a,function(a,b){var d=attributeToString(b.key);""!==d&&(c+="attributes["+d+"]="+attributeToString(b.value)+"&")}):"object"===typeof a&&null!==a&&jQuery.each(a,function(a,b){c+="attributes["+attributeToString(a)+"]="+attributeToString(b)+"&"});jQuery.ajax({type:"POST",url:"/cart/update.js",data:c,dataType:"json",success:function(a){if("function"===typeof b)b(a);else Shopify.onCartUpdate(a)},error:function(a,b){Shopify.onError(a,
b)}})};Shopify.updateCartNote=function(a,b){var c={type:"POST",url:"/cart/update.js",data:"note="+attributeToString(a),dataType:"json",success:function(a){if("function"===typeof b)b(a);else Shopify.onCartUpdate(a)},error:function(a,b){Shopify.onError(a,b)}};jQuery.ajax(c)};
"1.4"<=jQuery.fn.jquery?Shopify.param=jQuery.param:(Shopify.param=function(a){var b=[],c=function(a,c){c=jQuery.isFunction(c)?c():c;b[b.length]=encodeURIComponent(a)+"="+encodeURIComponent(c)};if(jQuery.isArray(a)||a.jquery)jQuery.each(a,function(){c(this.name,this.value)});else for(var d in a)Shopify.buildParams(d,a[d],c);return b.join("&").replace(/%20/g,"+")},Shopify.buildParams=function(a,b,c){jQuery.isArray(b)&&b.length?jQuery.each(b,function(b,e){rbracket.test(a)?c(a,e):Shopify.buildParams(a+
"["+("object"===typeof e||jQuery.isArray(e)?b:"")+"]",e,c)}):null!=b&&"object"===typeof b?Shopify.isEmptyObject(b)?c(a,""):jQuery.each(b,function(b,e){Shopify.buildParams(a+"["+b+"]",e,c)}):c(a,b)},Shopify.isEmptyObject=function(a){for(var b in a)return!1;return!0});function floatToString(a,b){var c=a.toFixed(b).toString();return c.match(/^\.\d+/)?"0"+c:c}function attributeToString(a){"string"!==typeof a&&(a+="","undefined"===a&&(a=""));return jQuery.trim(a)};
